(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('messaggio-voucher', {
            parent: 'entity',
            url: '/messaggio-voucher',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.messaggioVoucher.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/messaggio-voucher/messaggio-vouchers.html',
                    controller: 'MessaggioVoucherController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('messaggioVoucher');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('messaggio-voucher-detail', {
            parent: 'messaggio-voucher',
            url: '/messaggio-voucher/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.messaggioVoucher.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/messaggio-voucher/messaggio-voucher-detail.html',
                    controller: 'MessaggioVoucherDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('messaggioVoucher');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MessaggioVoucher', function($stateParams, MessaggioVoucher) {
                    return MessaggioVoucher.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'messaggio-voucher',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('messaggio-voucher-detail.edit', {
            parent: 'messaggio-voucher-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/messaggio-voucher/messaggio-voucher-dialog.html',
                    controller: 'MessaggioVoucherDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MessaggioVoucher', function(MessaggioVoucher) {
                            return MessaggioVoucher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('messaggio-voucher.new', {
            parent: 'messaggio-voucher',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/messaggio-voucher/messaggio-voucher-dialog.html',
                    controller: 'MessaggioVoucherDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                senderEmail: null,
                                recipientEmail: null,
                                ccEmail: null,
                                voucherCode: null,
                                subject: null,
                                body: null,
                                requestDate: null,
                                sendDate: null,
                                attempts: null,
                                success: null,
                                agreed: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('messaggio-voucher', null, { reload: 'messaggio-voucher' });
                }, function() {
                    $state.go('messaggio-voucher');
                });
            }]
        })
        .state('messaggio-voucher.edit', {
            parent: 'messaggio-voucher',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/messaggio-voucher/messaggio-voucher-dialog.html',
                    controller: 'MessaggioVoucherDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MessaggioVoucher', function(MessaggioVoucher) {
                            return MessaggioVoucher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('messaggio-voucher', null, { reload: 'messaggio-voucher' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('messaggio-voucher.delete', {
            parent: 'messaggio-voucher',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/messaggio-voucher/messaggio-voucher-delete-dialog.html',
                    controller: 'MessaggioVoucherDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MessaggioVoucher', function(MessaggioVoucher) {
                            return MessaggioVoucher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('messaggio-voucher', null, { reload: 'messaggio-voucher' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
